import { render, staticRenderFns } from "./SnsLogin.vue?vue&type=template&id=6bff63fa&scoped=true"
import script from "./SnsLogin.vue?vue&type=script&lang=js"
export * from "./SnsLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bff63fa",
  null
  
)

export default component.exports